import { useApiRequest } from "@hooks/use-api-request";
import { useQuery } from "@tanstack/react-query";

export const useCareerPlans = () => {
  const queryFn = useApiRequest({
    url: "/users/me/career-plans",
    params: { include_lightcast_data: true },
    method: "GET",
  });

  return useQuery({
    queryKey: ["user-career-plans"],
    queryFn,
  });
};
